(function () {
    'use strict';

    angular.module("imApp").factory("customerInvoicingService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerInvoicing: function (parms) {
                return $ihttp.post({
                    method: 2191,
                    parameters: parms || {}
                });
            },
            createInvoice: function (mergeObj) {
                return $ihttp.post({
                    method: 2193,
                    parameters: mergeObj
                });
            },
            setNotInvoice: function (mergeObj) {
                return $ihttp.post({
                    method: 2202,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
